module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/14-729488f3e787fac2a9ac9fddf69855dc.png";